// Stage 4: 录用审批&Offer - 3个模块
import { useApi, api } from '../api/client';
import { useActions } from '../actions';
import {
  PageHeader, ModuleBanner, Card, CardHead, Kpi, Tag, Status, Loading, ErrorBox,
} from '../components/UI';
import { MODULE_META } from '../config';
import { useAI } from '../components/AIPanel';

// ===== 4.1 薪酬定级 =====
export function SalaryApproval() {
  const meta = MODULE_META['salary-approval'];
  const { openCreate } = useActions();
  const { data, loading, error } = useApi(() => api.salaryApprovals(), [], 'salary-approvals');
  if (loading) return <Loading />;
  if (error || !data) return <ErrorBox message={error || ''} />;

  return (
    <div className="fade-in">
      <PageHeader
        title={meta.title}
        subtitle={meta.subtitle}
        stageBadge={meta.stageBadge}
        actions={<button className="btn btn-primary" onClick={() => openCreate('salary-approvals')}>+ 发起审批</button>}
      />
      <ModuleBanner title="薪酬方案审批" stageTag="Stage 4-1" />

      <div className="grid grid-4" style={{ marginBottom: 24 }}>
        <Kpi label="本月审批" value={19} trend={{ type: 'up', text: '通过 16' }} />
        <Kpi label="平均薪酬" value="¥48K" />
        <Kpi label="审批耗时" value="2.3" unit="天" />
        <Kpi label="预算使用" value={68} unit="%" />
      </div>

      <Card>
        <CardHead title="薪酬方案明细" />
        <table className="table">
          <thead>
            <tr>
              <th>候选人</th><th>岗位</th><th>职级</th>
              <th>基础月薪</th><th>奖金</th><th>股票</th><th>补贴</th>
              <th>年包</th><th>状态</th>
            </tr>
          </thead>
          <tbody>
            {data.map(s => (
              <tr key={s.id}>
                <td><b>{s.name}</b></td>
                <td>{s.position}</td>
                <td><Tag color="cinnabar">{s.level}</Tag></td>
                <td className="mono">¥{s.base.toLocaleString()}</td>
                <td>{s.bonus}</td>
                <td>{s.stock}</td>
                <td>{s.allowance}</td>
                <td><b className="text-cinnabar">{s.total}</b></td>
                <td><Status type={s.status === '审批通过' ? 'done' : 'progress'}>{s.status}</Status></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}

// ===== 4.2 背景调查 =====
export function BgCheck() {
  const meta = MODULE_META['bg-check'];
  const { openCreate } = useActions();
  const { data, loading, error } = useApi(() => api.bgChecks(), [], 'bg-checks');
  if (loading) return <Loading />;
  if (error || !data) return <ErrorBox message={error || ''} />;

  return (
    <div className="fade-in">
      <PageHeader
        title={meta.title}
        subtitle={meta.subtitle}
        stageBadge={meta.stageBadge}
        actions={<button className="btn btn-primary" onClick={() => openCreate('bg-checks')}>+ 发起背调</button>}
      />
      <ModuleBanner title="候选人背调工作台" stageTag="Stage 4-2" />

      <div className="grid grid-4" style={{ marginBottom: 24 }}>
        <Kpi label="本月背调" value={12} />
        <Kpi label="已完成" value={8} />
        <Kpi label="有问题" value={1} trend={{ type: 'down', text: '学历存疑' }} />
        <Kpi label="平均耗时" value="2.5" unit="天" />
      </div>

      <Card>
        <CardHead title="背调记录" sub="供应商：i背调 · 猎聘背调" />
        <table className="table">
          <thead>
            <tr><th>候选人</th><th>前公司</th><th>在职时间</th><th>职位</th><th>核验人</th><th>核验项</th><th>结果</th></tr>
          </thead>
          <tbody>
            {data.map(b => (
              <tr key={b.id}>
                <td><b>{b.name}</b></td>
                <td>{b.company}</td>
                <td className="text-sm">{b.period}</td>
                <td className="text-sm">{b.position}</td>
                <td className="text-sm">{b.verifier}</td>
                <td className="text-sm text-ink-3">{b.items}</td>
                <td><Status type={b.result === '已核实' ? 'done' : 'progress'}>{b.result}</Status></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}

// ===== 4.3 发放 Offer =====
export function OfferSend() {
  const meta = MODULE_META['offer-send'];
  const { toast, openCreate } = useActions();
  const { open: openAI } = useAI();
  const { data, loading, error } = useApi(() => api.offers(), [], 'offers');
  if (loading) return <Loading />;
  if (error || !data) return <ErrorBox message={error || ''} />;

  return (
    <div className="fade-in">
      <PageHeader
        title={meta.title}
        subtitle={meta.subtitle}
        stageBadge={meta.stageBadge}
        actions={
          <>
            <button className="btn btn-primary" onClick={() => openCreate('offers')}>+ 制作 Offer</button>
            <button className="btn btn-ghost" onClick={() => toast('模板库开发中')}>模板库</button>
            <button className="btn btn-accent" onClick={() => openAI('AI 写 Offer', (m) => api.aiOfferDraft({name:'张明远',position:'高级前端工程师',level:'P7',salary:'52K',dept:'产品研发部'}))}>AI 写 Offer</button>
          </>
        }
      />
      <ModuleBanner title="Offer 模板预览" stageTag="Stage 4-3" />

      <div className="offer-doc">
        <div className="offer-seal">
          <div style={{ fontSize: 11, letterSpacing: 2, marginBottom: 2 }}>OFFER</div>
          <div>TALENT</div>
        </div>
        <h2>聘 用 确 认 函</h2>
        <div className="offer-meta">OFFER LETTER · No. 2026-OFR-0088</div>
        <div className="offer-body">
          <p><b>张明远</b> 先生/女士：</p>
          <p>非常荣幸地通知您，经过我司严格的筛选与评估，您已成功通过 <b>高级前端工程师（P7）</b> 岗位的全部面试环节。我们诚挚邀请您加入公司，与我们一起创造卓越的产品与服务。</p>
          <p>现将录用事宜通知如下：</p>
          <table className="offer-table">
            <tbody>
              <tr><td>拟聘岗位</td><td>高级前端工程师（中台方向）</td></tr>
              <tr><td>职级</td><td>P7</td></tr>
              <tr><td>汇报对象</td><td>前端 Leader</td></tr>
              <tr><td>基本月薪</td><td>¥52,000（税前）</td></tr>
              <tr><td>年终奖金</td><td>15 薪（含 3 个月绩效奖金）</td></tr>
              <tr><td>股票激励</td><td>300 股/年，分 4 年归属</td></tr>
              <tr><td>补贴福利</td><td>餐补 1,500/月 · 通讯补贴 300/月</td></tr>
              <tr><td>工作地点</td><td>北京 · 望京</td></tr>
              <tr><td>入职日期</td><td>2026 年 8 月 1 日（周五）</td></tr>
              <tr><td>试用期</td><td>3 个月 · 期间薪资按 80% 发放</td></tr>
            </tbody>
          </table>
          <p>请您于 <b>2026 年 7 月 12 日 18:00 前</b> 通过本函回复邮件予以确认。逾期未回复者，视为放弃本次录用机会。</p>
          <p>报到所需材料：身份证、学历/学位证书原件、离职证明、近 6 个月体检报告、社保转移单、银行卡等。</p>
          <p style={{ marginTop: 24, textAlign: 'right' }}>TALENT Tech Co., Ltd.<br />人力资源部 · 2026 年 7 月 5 日</p>
        </div>
      </div>

      <div className="card" style={{ marginTop: 24 }}>
        <CardHead title="Offer 发放记录" sub={`本月共 ${data.length} 份`} />
        <table className="table">
          <thead>
            <tr><th>候选人</th><th>岗位</th><th>薪酬方案</th><th>发放日期</th><th>状态</th><th>预计入职</th></tr>
          </thead>
          <tbody>
            {data.map(o => (
              <tr key={o.id}>
                <td><b>{o.name}</b></td>
                <td>{o.position}</td>
                <td><b className="text-cinnabar">{o.salary}</b></td>
                <td className="mono text-xs">{o.date}</td>
                <td><Tag color={o.status === '已接受' ? 'bamboo' : 'gold'}>{o.status}</Tag></td>
                <td className="mono text-xs">{o.onboard}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
